import React, { FC, useEffect, useState } from 'react';
import Select from '@domain-group/fe-co-select';
import { useStatus } from '../status-store';
import * as PortalApi from '../../lib/portal-api';

interface ProjectListProps {
  teamId?: string;
  onChange: (selectedCredential: PortalApi.ProjectViewModel) => void;
}

interface SelectOption {
  label: string;
  value: string;
  data: PortalApi.ProjectViewModel;
}

const ProjectList: FC<ProjectListProps> = ({ teamId, onChange }) => {
  const status = useStatus();
  const [options, updateOptionList] = useState<SelectOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchOptionList = async () => {
      setIsLoading(true);
      if (teamId) {
        const projects = await PortalApi.getProjects(
          status.accessToken,
          teamId,
        );
        updateOptionList(
          projects.map((project) => ({
            label: `${project.name} (${project.environment})`,
            value: project.id,
            data: project,
          })),
        );
      } else {
        updateOptionList([]);
      }
      setIsLoading(false);
    };
    fetchOptionList();
  }, [teamId, status.accessToken]);

  return isLoading || options.length > 0 ? (
    <Select
      instanceId="swagger-project-chooser"
      stretched
      label="Choose Project"
      labelHidden={false}
      placeholder="Choose Project"
      options={options}
      loading={isLoading}
      nowrap
      onChange={async (selectedItem: SelectOption) =>
        onChange(selectedItem.data)
      }
    />
  ) : (
    <p>
      No Projects Created.{' '}
      <a href="/docs/latest/getting-started/creating-first-project">
        Create a project to begin
      </a>
    </p>
  );
};

export default ProjectList;
